<button [ngClass]="[isDisabledClass]">
    <fa-icon [icon]="[iconPrefix, icon]"
             [classes]="[isDisabledClass]"
             transform="transform"
             [rotate]="rotate"
             [styles]="{'color': color, 'font-size': fontSize}"
    ></fa-icon>
</button>
